import { render, staticRenderFns } from "./BtzAccidents.vue?vue&type=template&id=a3eca45a&scoped=true"
import script from "./BtzAccidents.vue?vue&type=script&lang=js"
export * from "./BtzAccidents.vue?vue&type=script&lang=js"
import style0 from "./BtzAccidents.vue?vue&type=style&index=0&id=a3eca45a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3eca45a",
  null
  
)

export default component.exports